<template>
	<o-page
		id="order-status-helper"
		title="Aide pour le suivi de la commande"
		class="order-details-status-helper">
		<o-section class="order-details-status-helper__section">
			<h4 class="order-details-status-helper__section-title">
				Le suivi des candidats
			</h4>
			<p class="order-details-status-helper__paragraph">
				Nous avons conscience que cette vue comporte de nombreux changements et nouveautés auxquelles vous
				n’étiez pas encore habitués, laissez-nous vous présenter comment ça marche !
			</p>

			<p class="order-details-status-helper__paragraph">
				Dans cette liste, vous retrouverez les différents candidats que vous avez placés sur la commande au niveau
				du <span>Suivi des candidats</span>. Vous pourrez voir d’un coup d’oeil ce qu’il manque au candidat, voir la réponse
				du client et du candidat.
			</p>
		</o-section>
		<o-section
			id="order-details-status-helper-legend"
			class="order-details-status-helper__section">
			<h4 class="order-details-status-helper__section-title">
				Légende
			</h4>
			<div class="order-details-status-helper__legend-header">
				<div
					v-for="(status, index) in setup.statusOptions"
					:key="index"
					class="order-details-status-helper__legend-nav"
					:class="{ 'order-details-status-helper__legend-nav--active': setup.isActive(status.state) }"
					@click="setup.activeTab = status.state">
					<shared-state-icon :state="status.state"/>
					<span class="order-details-status-helper__legend-nav-label">{{ status.label }}</span>
				</div>
			</div>
			<div class="order-details-status-helper__legend-content">
				<!-- <h4 class="order-details-status-helper__section-title">
					Explication :
				</h4> -->
				<div v-html="setup.activeTabContent"/>
			</div>
		</o-section>
		<div class="order-details-status-helper__background">
			<div
				class="candidates-status__legend">
				<div class="candidates-status-row">
					<div class="candidates-status-col candidates-status-col--name"/>

					<div class="candidates-status-col-group">
						<div
							v-tooltip="'Disponible'"
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Disponibilités') }">
							Disp.
						</div>
						<div
							v-tooltip="'Qualification'"
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Qualification') }">
							Qual.
						</div>
						<div
							v-tooltip="'Langues'"
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Langues') }">
							Lang.
						</div>
						<div
							v-tooltip="'Véhicule'"
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Véhicule') }">
							Véhi.
						</div>
						<div
							v-tooltip="'Documents'"
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Documents') }">
							Docs.
						</div>
					</div>

					<div class="candidates-status-col-group">
						<div
							v-tooltip="'Candidats'"
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Candidat') }">
							Cand.
						</div>
						<div
							v-tooltip="'Clients'"
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Client') }">
							Client
						</div>
					</div>

					<div class="candidates-status-col candidates-status-col--validated no-before">Validé</div>
				</div>
			</div>
			<o-sticker
				id="candidate-sticker-helper"
				class="candidate-sticker">
				<div class="candidates-status-row">
					<span class="candidates-status-col candidates-status-col--name candidate-sticker__name"> Nom de l'intérimaire</span>

					<div class="candidates-status-col-group candidate-sticker__state-group">
						<div
							class="candidates-status-col"
							:class="{
								'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Disponibilités'),
								'order-details-status-helper__candidates-status-col--highlight' : setup.activeTabState === 'warning',
							}">
							<shared-state-icon
								:style=" setup.activeTabState === 'warning' ? 'cursor: pointer;' : ''"
								:state="setup.setPossibleColor('Disponibilités')"
								:clickable="setup.activeTabState === 'warning'"
								@click="setup.activeTabState === 'warning' ? setup.handleIconClick('availability') : null"/>
						</div>
						<div
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Qualification') }">
							<shared-state-icon
								:state="setup.setPossibleColor('Qualification')"/>
						</div>
						<div
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Langues') }">
							<shared-state-icon
								:state="setup.setPossibleColor('Langues')"/>
						</div>
						<div
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Véhicule') }">
							<shared-state-icon
								:state="setup.setPossibleColor('Véhicule')"/>
						</div>
						<div
							class="candidates-status-col"
							:class="{
								'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Documents'),
								'order-details-status-helper__candidates-status-col--highlight' : setup.activeTabState === 'warning',
							}">
							<shared-state-icon
								:style=" setup.activeTabState === 'warning' ? 'cursor: pointer;' : ''"
								:state="setup.setPossibleColor('Documents')"
								:clickable="setup.activeTabState === 'warning'"
								@click="setup.activeTabState === 'warning' ? setup.handleIconClick('documents') : null"/>
						</div>
					</div>

					<div class="candidates-status-col-group candidate-sticker__state-group">
						<div
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Candidat') }">
							<shared-state-icon
								:state="setup.setPossibleColor('Candidat')"/>
						</div>
						<div
							class="candidates-status-col"
							:class="{ 'order-details-status-helper__candidates-status-col--see-through' : !setup.hasActiveState('Client') }">
							<shared-state-icon
								:state="setup.setPossibleColor('Client')"/>
						</div>
					</div>

					<div class="candidates-status-col candidates-status-col--validated candidate-sticker-validated">
						<shared-state-icon :state="setup.setPossibleColor('Validé')"/>
					</div>
				</div>
			</o-sticker>
		</div>
		<o-alert
			v-if="setup.activeTabState === 'warning'"
			color="info">
			Petite particularité pour les <b>documents</b>, <br>
			vous pouvez cliquer sur la pastille pour demander le partage des documents manquants
		</o-alert>
	</o-page>
</template>

<script setup lang="ts">
import OrderDetailsStatusHelperSetupService from '@/setup/order/OrderDetailsStatusHelperSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(OrderDetailsStatusHelperSetupService.props);
const setup = new OrderDetailsStatusHelperSetupService(props, _aside);
</script>

<style lang="less" scoped>
@import '@/styles/mixins';

.order-details-status-helper {
	&__section-title {
		margin-bottom: 1rem;
	}
	&__background {
		margin: 1rem 0 1rem;
		padding: 1.5rem;
		background: var(--grey-lighter);
		border-radius: 0.25rem;
	}

	&__legend-header {
		display: flex;
		align-items: center;
		gap: 1rem;
	}
	&__legend-nav {
		flex: 1;
		padding: 0.75rem;
		border-radius: 0.25rem;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		border: 1px solid var(--grey-light);
		cursor: pointer;
		transition: all .3s;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		&:hover:not(.order-details-status-helper__legend-nav--active) {
			background: var(--grey-lighter);
		}
		&--active {
			background: rgba(var(--rgb-info), 0.1);
			border: 1px solid var(--info);
			transform: translateY(0.25rem);
		}
	}
	&__legend-nav-circle {
		border-radius: 50%;
		background: var(--grey);
		height: 1rem;
		width: 1rem;
	}
	&__legend-nav-label {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	&__legend-content {
		padding: 1.5rem 0 1rem;
	}
	&__candidates-status-col {
		&--see-through {
			opacity: .3;
		}
		&--highlight {
			.shared-state-icon {
				&::after {
					content: "";
					position: absolute;
					background: inherit;
					opacity: 0.7;
					height: 100%;
					width: 100%;
					border-radius: 50%;
					animation: highlight infinite;
					animation-duration: 2s;
				}
			}
		}
	}
}

.candidates-status {
	position: relative;

	&__container {
		position: relative;
	}

	&__help-icon {
		position: absolute;
		top: 0.3rem;
		left: 11.5rem;
		font-size: 1.2rem;
	}

	&__legend {
		padding: 0.75rem 1rem;
		color: var(--grey-dark);
		// margin-top: -3.5rem;
		> div {
      text-align: center;
			font-size: 0.75rem
		}
	}

	&__empty-temp {
		padding: 1.5rem 1.5rem;
		background: var(--grey-light);
		border-radius: 0.25rem;
		display: flex;
		align-items: center;
		color: var(--grey-darker);
		gap: 1rem;
		opacity: 0.5;

		&::after {
			position: absolute;
			content:'';
			width: 1rem;
			height: 1rem;
			border-radius: 50%;
			background: var(--grey);
			right: 3rem;
		}

		+ .candidates-status__empty-temp {
			margin-top: 0.5rem;
		}
	}
}

.candidates-status-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
}

.candidates-status-col-group {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	gap: 0.5rem;

	flex: 5;

	& + & {
		flex: 2;
	}
}

.candidates-status-col {

	.flex-align();
	text-align: center;
	flex: 0 0 3rem;

	&--name {
		justify-content: flex-start;
		flex: 0 0 10rem;
	}

	&--validated {
		flex: 1;

		.candidates-status__legend & {

			/* &::before {
				content: "";
				display: block;
				background-color: rgba(white, 0.5);
				position: absolute;
				top: -0.5rem;
				right: 0;
				width: 5.5rem;
				bottom: -1rem;
				z-index: 1;
				box-shadow: 0 0.7rem 2rem rgb(0 0 0 / 10%);
				border-radius: var(--radius-sticker);
			} */

			&::after {
				content: "Validé";
				display: block;
				position: absolute;
				z-index: 2;
			}
		}
	}

	.shared-state-icon {
		z-index: 3;
		position: relative;
	}
}
.no-before {
	&::before {
		display: none !important;
	}
}

@keyframes highlight {
	0% {
		transform: scale(1);
		opacity: 0.7;
	}
	100% {
		transform: scale(2);
		opacity: 0.3;
	}
}


</style>
